import type { TPlayer } from 'video.js'
import type { TogglePopupEvent } from '|>/shared/events'

export function applyTogglePopupClass(
  player: TPlayer | null | undefined,
  event: TogglePopupEvent | undefined
): void {
  if (event && player && typeof event.className === 'string') {
    player.toggleClass(event.className, Boolean(event.isOpen))
  }
}
